import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { Logo } from './Logo';
import { ProductDetail } from './ProductDetail';
import { useClickSound } from '../hooks/useClickSound';
export interface Product {
  id: number;
  name: string;
  price: string;
  energy: string;
  description: string;
  image: string;
  heroImage: string;
  longDescription: string;
  synergyTitle: string;
  synergyDescription: string;
  features: {
    icon: string;
    label: string;
  }[];
  specs: string[];
  reviews: {
    stars: number;
    text: string;
    author: string;
    title: string;
  }[];
}
interface BoutiqueProps {
  onClose: () => void;
  onGoHome: () => void;
}
const products: Product[] = [{
  id: 1,
  name: 'Zestaw Aromaterapii',
  price: '89 zł',
  energy: '+500',
  description: 'Olejki eteryczne do wyciszenia przed snem',
  image: 'https://images.unsplash.com/photo-1599305090598-fe179d501227?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1599305090598-fe179d501227?w=800&q=80&fit=crop',
  longDescription: 'Najwyższej jakości olejki eteryczne pozyskiwane z ekologicznych upraw. Zestaw zawiera starannie wyselekcjonowane esencje z lawendy, rumianku i bergamotki, które naturalnie obniżają poziom kortyzolu i przygotowują ciało do głębokiej regeneracji.',
  synergyTitle: 'Idealne do: Rytuał Oddechowy',
  synergyDescription: 'Rozpyl olejek lawendowy podczas ćwiczeń oddechowych w aplikacji. Połączenie aromaterapii z prowadzonym oddechem pudełkowym dwukrotnie szybciej wprowadza układ nerwowy w stan przywspółczulny.',
  features: [{
    icon: 'Leaf',
    label: '100% Eko'
  }, {
    icon: 'Droplets',
    label: 'Czysty Skład'
  }, {
    icon: 'Moon',
    label: 'Lepszy Sen'
  }],
  specs: ['Pojemność: 3x 10ml', 'Skład: 100% naturalne olejki eteryczne (Lawenda, Rumianek, Bergamotka)', 'Certyfikat: BIO i Cruelty-Free', 'Opakowanie: Szkło z recyklingu'],
  reviews: [{
    stars: 5,
    title: 'Cudowny zapach',
    text: 'Używam co wieczór przed snem. Lawenda jest niesamowicie relaksująca.',
    author: 'Anna K. • Potwierdzony zakup'
  }]
}, {
  id: 2,
  name: 'Mata Pranamat',
  price: '249 zł',
  energy: '+1200',
  description: 'Akupresura dla głębokiego relaksu ciała',
  image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80&fit=crop',
  longDescription: 'Stworzona z naturalnego lnu i włókna kokosowego. Tysiące kolców stymuluje przepływ krwi, fizycznie rozbijając tzw. "zbroję stresową" zgromadzoną w karku i plecach po całym dniu pracy.',
  synergyTitle: 'Idealna do: Głęboki Sen',
  synergyDescription: 'Połóż się na macie na 15 minut, włączając moduł Fal Delta w AuraSync. Uwolnienie endorfin z akupresury potęguje działanie dźwięku, zapewniając niespotykanie głęboki sen.',
  features: [{
    icon: 'Leaf',
    label: '100% Eko'
  }, {
    icon: 'Droplets',
    label: 'Poprawa Krążenia'
  }, {
    icon: 'Bed',
    label: 'Lepszy Sen'
  }],
  specs: ['Wymiary: 72 x 44 cm (idealna na całe plecy)', 'Materiały: 100% naturalny len, wypełnienie z organicznego włókna kokosowego', 'Kolce (Rozetki): Hipoalergiczny, certyfikowany plastik HIPS ułożony w kształt kwiatu lotosu', 'Waga: 1.2 kg'],
  reviews: [{
    stars: 5,
    title: 'Zasypiam na tym w 10 minut.',
    text: 'Początkowo trochę kłuje, ale po 2 minutach rozlewa się niesamowite ciepło. W połączeniu z modułem Głębokiego Snu z aplikacji działa cuda.',
    author: 'Katarzyna W. • Potwierdzony zakup'
  }, {
    stars: 4.5,
    title: 'Niezastąpiona po pracy przed komputerem',
    text: 'Super jakość materiałów. Kładę się na niej codziennie po południu podczas analizy ze skanera aury. Bóle karku ustąpiły.',
    author: 'Michał T. • Potwierdzony zakup'
  }]
}, {
  id: 3,
  name: 'Kryształ Ametyst',
  price: '59 zł',
  energy: '+300',
  description: 'Kamień spokoju i intuicji',
  image: 'https://images.unsplash.com/photo-1603344797033-f0f4f587ab60?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1603344797033-f0f4f587ab60?w=800&q=80&fit=crop',
  longDescription: 'Surowy, nieoszlifowany ametyst o głębokiej fioletowej barwie. Znany ze swoich właściwości wyciszających i transformujących negatywną energię w spokój.',
  synergyTitle: 'Idealny do: Oczyszczanie Czakr',
  synergyDescription: 'Trzymaj kryształ w dłoni podczas sesji Oczyszczania Czakr. Jego naturalna wibracja rezonuje z czakrą trzeciego oka, pogłębiając stan medytacyjny.',
  features: [{
    icon: 'Leaf',
    label: 'Naturalny'
  }, {
    icon: 'Moon',
    label: 'Spokój'
  }, {
    icon: 'Droplets',
    label: 'Oczyszczenie'
  }],
  specs: ['Waga: ok. 150-200g', 'Pochodzenie: Brazylia', 'Każdy kamień jest unikalny i może różnić się kształtem'],
  reviews: [{
    stars: 5,
    title: 'Piękny okaz',
    text: 'Kryształ jest przepiękny, ma głęboki kolor i idealnie mieści się w dłoni podczas medytacji.',
    author: 'Magda S. • Potwierdzony zakup'
  }]
}, {
  id: 4,
  name: 'Świeca Sojowa',
  price: '45 zł',
  energy: '+200',
  description: 'Naturalna aromaterapia lawendowa',
  image: 'https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?w=800&q=80&fit=crop',
  longDescription: 'Ręcznie rozlewana świeca z ekologicznego wosku sojowego. Wzbogacona naturalnymi olejkami eterycznymi, tworzy w pomieszczeniu aurę harmonii i bezpieczeństwa.',
  synergyTitle: 'Idealna do: Detoks Przekonań',
  synergyDescription: 'Zapal świecę przed rozpoczęciem sesji Detoksu Przekonań. Płomień pomaga skupić wzrok i szybciej wejść w stan fal Theta.',
  features: [{
    icon: 'Leaf',
    label: 'Wosk Sojowy'
  }, {
    icon: 'Droplets',
    label: 'Bez Toksyn'
  }, {
    icon: 'Moon',
    label: 'Długie Palenie'
  }],
  specs: ['Czas palenia: ok. 40 godzin', 'Skład: 100% wosk sojowy, bawełniany knot', 'Zapach: Lawenda z nutą drzewa sandałowego'],
  reviews: [{
    stars: 5,
    title: 'Relaksujący zapach',
    text: 'Pachnie obłędnie, a zapach unosi się w całym domu. Bardzo wydajna.',
    author: 'Ewa M. • Potwierdzony zakup'
  }]
}, {
  id: 5,
  name: 'Herbata Zen',
  price: '35 zł',
  energy: '+150',
  description: 'Mieszanka ziół na wyciszenie',
  image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=800&q=80&fit=crop',
  longDescription: 'Autorska kompozycja ziół adaptogennych i relaksujących. Delikatny smak melisy, męczennicy i ashwagandhy pomaga zrzucić napięcie po intensywnym dniu.',
  synergyTitle: 'Idealna do: Codzienny Rytuał',
  synergyDescription: 'Wypij filiżankę ciepłego naparu 30 minut przed rozpoczęciem wieczornego Rytuału. Zioła przygotują Twoje ciało na głęboką pracę z dźwiękiem.',
  features: [{
    icon: 'Leaf',
    label: 'Zioła BIO'
  }, {
    icon: 'Droplets',
    label: 'Adaptogeny'
  }, {
    icon: 'Moon',
    label: 'Wyciszenie'
  }],
  specs: ['Waga: 50g (ok. 25 porcji)', 'Skład: Melisa, Męczennica, Ashwagandha, Kwiat lipy', 'Sposób parzenia: 1 łyżeczka na kubek, parzyć 10 min pod przykryciem'],
  reviews: [{
    stars: 4.5,
    title: 'Bardzo smaczna',
    text: 'Świetnie wycisza przed snem. Smak jest delikatny, ziołowy, nie narzuca się.',
    author: 'Piotr K. • Potwierdzony zakup'
  }]
}, {
  id: 6,
  name: 'Dziennik Wdzięczności',
  price: '49 zł',
  energy: '+250',
  description: 'Codzienna praktyka mindfulness',
  image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=200&h=200&fit=crop',
  heroImage: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=800&q=80&fit=crop',
  longDescription: 'Pięknie wydany notatnik w twardej oprawie, zaprojektowany do codziennej praktyki wdzięczności. Zawiera inspirujące cytaty i miejsce na poranne oraz wieczorne refleksje.',
  synergyTitle: 'Idealny do: Afirmacje',
  synergyDescription: 'Zapisz swoje ulubione afirmacje z aplikacji w dzienniku. Fizyczne przelanie myśli na papier wzmacnia proces manifestacji i programowania podświadomości.',
  features: [{
    icon: 'Leaf',
    label: 'Papier Eko'
  }, {
    icon: 'Moon',
    label: 'Mindfulness'
  }, {
    icon: 'Droplets',
    label: 'Rozwój'
  }],
  specs: ['Format: A5', 'Liczba stron: 192', 'Papier: 100g/m2, certyfikat FSC', 'Dodatki: Tasiemka do zaznaczania stron'],
  reviews: [{
    stars: 5,
    title: 'Zmienia perspektywę',
    text: 'Codzienne pisanie w tym dzienniku bardzo pomaga mi skupić się na pozytywach. Piękne wydanie.',
    author: 'Karolina J. • Potwierdzony zakup'
  }]
}];
export function Boutique({
  onClose,
  onGoHome
}: BoutiqueProps) {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const {
    playClick
  } = useClickSound();
  const handleProductClick = (product: Product) => {
    playClick();
    setSelectedProduct(product);
  };
  return <AnimatePresence mode="wait" data-id="element-265">
      {selectedProduct ? <ProductDetail key="detail" product={selectedProduct} onClose={() => {
      playClick();
      setSelectedProduct(null);
    }} data-id="element-266" /> : <motion.div key="list" className="flex flex-col items-center w-full max-w-lg z-10 pb-8 mt-4 p-4 min-h-screen" initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -20
    }} transition={{
      duration: 0.4
    }} data-id="element-267">
          {/* Header */}
          <div className="w-full flex items-center justify-between mb-8 px-2" data-id="element-268">
            <button onClick={() => {
          playClick();
          onClose();
        }} className="w-10 h-10 rounded-full bg-white border border-slate-100 flex items-center justify-center text-slate-500 hover:text-zen-accent hover:border-zen-accent/30 transition-colors shadow-sm" aria-label="Wróć" data-id="element-269">
              <ArrowLeft className="w-5 h-5" data-id="element-270" />
            </button>
            <Logo onClick={() => {
          playClick();
          onGoHome();
        }} data-id="element-271" />
            <div className="w-10 h-10" data-id="element-272"></div> {/* Spacer for centering */}
          </div>

          <div className="w-full text-center mb-8" data-id="element-273">
            <h2 className="text-2xl font-light text-zen-text mb-1" data-id="element-274">
              Butik Dobrostanu
            </h2>
            <p className="text-xs text-slate-400" data-id="element-275">
              Produkty wspierające Twoją praktykę
            </p>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-2 gap-4 w-full" data-id="element-276">
            {products.map(product => <div key={product.id} className="clean-panel rounded-2xl p-4 flex flex-col items-center relative overflow-hidden group cursor-pointer" onClick={() => handleProductClick(product)} data-id="element-277">
                <div className="absolute top-0 right-0 bg-yellow-100 text-yellow-700 text-[10px] px-2 py-1 rounded-bl-xl font-bold flex items-center z-10" data-id="element-278">
                  {product.energy}{' '}
                  <Sparkles className="w-3 h-3 ml-1" fill="currentColor" data-id="element-279" />
                </div>
                <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border border-slate-100 shadow-sm" data-id="element-280">
                  <img src={product.image} className="w-full h-full object-cover transition-transform group-hover:scale-110 duration-500" alt={product.name} data-id="element-281" />
                </div>
                <h4 className="text-sm font-semibold text-zen-text text-center mb-1" data-id="element-282">
                  {product.name}
                </h4>
                <p className="text-[10px] text-slate-500 text-center mb-2 h-8" data-id="element-283">
                  {product.description}
                </p>
                <div className="text-sm font-bold text-zen-text mb-4" data-id="element-284">
                  {product.price}
                </div>
                <button className="w-full bg-zen-bg hover:bg-slate-50 border border-slate-200 rounded-xl py-2.5 text-xs text-zen-text font-medium transition-colors flex justify-center items-center mt-auto" onClick={e => {
            e.stopPropagation();
            handleProductClick(product);
          }} data-id="element-285">
                  Kup teraz
                </button>
              </div>)}
          </div>
        </motion.div>}
    </AnimatePresence>;
}